<template>
  <div class="fathera" style="">
    <div class="dyh-line-group" style="">
      <b class="dyh-line-group-label"> 用 户 授 权 </b>
      <div style="padding: 20px;width: calc(100% - 300px);">
        <el-input size="mini" placeholder="请输入用户名搜索：" v-model="select_data.search_value" class="input-with-select"
          @change="searchPeople">
          <el-select slot="prepend" clearable style="width: 250px !important" @visible-change="optionShow"
            placeholder="通过角色快速查找" v-model="select_data.role_id">
            <el-option v-for="(item, index) in role_list" :key="index" :label="item.role_name"
              :value="item.role_id"></el-option>
          </el-select>
          <el-button slot="append" @click="reset" icon="el-icon-refresh">重置</el-button>
        </el-input>
      </div>

      <el-button type="primary" size="small" style="width: 150px" @click="dialogChange(true, 'create')">新增用户</el-button>
      <el-button type="success" size="small" style="width: 150px" @click="activeAllOffline">激活所有用户</el-button>
    </div>
    <div class="people dyh-body-group" style="width: 100%;">
      <div style="width: 100%;">
        <!-- <wty-table ref="wtyTableRef" :who="who" :operate="'删除'" :wtycolumnList="tableClumn"
          :wtytbheigh="`${scroll_height}px`" :wtytbList="people_list" @deleteRow="deleteRow" @wtyTbreturn="wtyTbreturn"
          @updatePromiss="updatePromiss"></wty-table> -->
        <el-table ref="wtyTableRef" border :fit="true" :data="people_list" size="mini" type="index" height="520px"
          class="show-table" style="height: 100%; width:100%" :cell-style="{ padding: '0px 0' }" :header-cell-style="{
            height: '20px',
            background: '#409eff',
            color: '#fff',
          }">
          <el-table-column type="index" align="center" label="行号">
          </el-table-column>
          <el-table-column v-if="who == 'merchant'" prop="group_id" align="center" label="组id" fiexd="false"
            width="200"></el-table-column>
          <el-table-column v-for="(item, index) in wtycolumnList" :formatter="item.prop === 'role' ? formatter : null"
            :key="index" :prop="item.prop" :align="item.align" :label="item.label"
            :width="item.width"><!-- formatter 数据过滤 -->
          </el-table-column>

          <el-table-column align="center" width="250" fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button type="" @click="dialogChange(true, 'modify', scope.row)" size="mini">修改用户角色</el-button>
              <el-button type="danger" @click="dialogChange(true, 'del', scope.row)" size="mini">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="dialog_title" :close-on-click-modal="false" :visible.sync="showDialog" width="800px" top="3vh"
      style="margin-top: 0px" center>
      <div style="display: flex;flex-direction: column;">
        <el-form label-width="150px" style="min-width: 350px; margin-right: 20px">
          <el-form-item :label="is_phone ? '授权电话：' : '授权id：'">
            <el-input style="width: 550px" :disabled="accid_disabled" v-model="permission_data.account_id"
              :placeholder="is_phone ? '请输入授权电话' : '请输入授权id'"></el-input>
          </el-form-item>
          <el-form-item v-if="who == 'permission' || who == 'peopleinfo'" label="用户角色：">
            <el-select style="width: 550px !important" multiple :multiple-limit="3" @change="RoleIdChange"
              @visible-change="optionShow" placeholder="请选择用户角色" v-model="permission_data.role_id">
              <el-option v-for="(item, index) in role_list" :key="index" :label="item.role_name"
                :value="item.role_id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="permission-fa">
          <all-permission :treeData="treeData" :disabled="true" ref="allPermissionRef" @checkedChange="checkedChange"
            @merchantSet="merchantSet" :height="`${scroll_height - 180}`"></all-permission>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogSureClick">确 定</el-button>
        <el-button @click="showDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { deleteTabRepeat, showDialog } from "@/js/public.js";
import allPermission from "@/components/allPermission";
import wtyTable from "@/components/wty-table";
import {
  getServiceRoleList,
  setAccountPermission,
  delAccountPermission,
  //baseinfoListAccount,
  getAccountPermission,
  /* eslint-disable */
  accountSet,
  accountQuery,
  accountSearch,
  accountDe,
  roleQuery,
  accountList
  /* eslint-enable */
} from "@/api/service.js";
/* eslint-disable */
import {
  setAccountPermissionASMerchant,
  delAccountPermissionASMerchant,
  queryAccountPermissionASMerchant,
  MusergroupQuery,
  permissionMerchantSet, //店铺授权
  permissionMerchantDelete, //删除店铺权限
  permissionMerchantQuery, //查询店铺授权
  permissionMerchantList,
  mListAccount,
  mUserRoleList,
  mQueryAccount,
  mSetRole,
  mActiveOfflinePermission,
  mDeleteAccount
} from "@/api/merchant.js";
/* eslint-disable */
import { testR } from "../api/common";
export default {
  name: "wtyPermission",
  props: ["who", "perssionData", "tableList", "tableClumn"],
  data() {
    return {
      iscreate: true,
      showDialog: false,
      dialog_title: "",
      wtycolumnList: this.setColumn(),
      is_phone: false, //是否用手机号
      scroll_height: "", //计算的高度
      accid_disabled: false, //授权id是否允许输入
      table_show: "peoplepermisslist",
      row: -1,
      people_list: [],//过滤之后的受过权限的用户
      all_people_list: [],//所有受过权限的用户
      service_list: [],
      shop_list: [],
      treeData: [],
      treeData6: [],
      permission_data: {
        role_name: [],
        role_id: [],
        account_id: "",
        group_id: ""
      },
      //group_data: {},
      role_list: [],
      select_data: {
        role_id: "",
        search_value: ""
      },
      checked_list: [],
      get_checkedlist: []
    };
  },
  components: {
    allPermission,
    wtyTable
  },
  watch: {
    innerWH: {
      handler(newinner, oldinner) {
        if (newinner.innerHeight < 700) {
          this.scroll_height = newinner.innerHeight - 160;
        } else {
          this.scroll_height = newinner.innerHeight - 180;
        }
      },
      deep: true,
      immediate: true
    },
    "select_data.role_id": {
      handler(newval, oldval) {
        // console.log("newval", newval);
        if (newval === "") {
          if (this.people_list.length !== this.all_people_list.length) this.getAll();
          return;
        }
        let filter_list = [];
        this.all_people_list.forEach((item, index) => {
          if (item.role_id && item.role_id.includes(newval)) {
            filter_list.push(item);
          }
        });
        this.people_list = filter_list;
      },
      deep: true
    }
  },
  computed: {
    /* availWH() {
      return this.$store.state.resolution.availWH;
    }, */
    innerWH() {
      return this.$store.state.resolution.innerWH;
    }
  },
  async created() {
    this.treeData = [];
    this.treeData6 = [];
    this.treeData = this.perssionData.t2;
    this.treeData6 = this.perssionData.t6;
    //获取左边店铺的所有成员
    this.table_show = false;
    this.people_list = [];
    //所有受过权限的用户
    this.people_list = this.tableList;
    this.table_show = true;
    this.optionShow(true);
    this.getAll();

  },

  methods: {
    //TODO: 这边还没用 需要测试
    /**
     * 激活所有用户并缓存到线下
     */
    async activeAllOffline() {
      const result = await mActiveOfflinePermission();
      console.log("激活所有用户", result);
      if (result.state === true) this.successMessage(result.message);
    },
    /**
     * 重置搜索
     */
    reset() {
      this.select_data.search_value = "";
      this.select_data.role_id = "";
      this.people_list = this.all_people_list;
    },
    /**
     * 搜索用户
     */
    searchPeople() {
      const str = this.select_data.role_id;
      this.select_data.role_id = "";
      if (this.select_data.search_value === "") {
        if (this.people_list.length !== this.all_people_list.length) this.people_list = this.all_people_list;
        return;
      }
      let filter_list = [];
      this.all_people_list.forEach((item, index) => {
        if (item.account_name && item.account_name.includes(this.select_data.search_value)) {
          filter_list.push(item);
        }
      });
      this.people_list = filter_list;
      this.select_data.role_id = str;
    },
    /**
    * 点击模态框确定按钮
    */
    async dialogSureClick() {
      if (this.who === "permission") {
        const result = await accountSet(this.permission_data.account_id, this.permission_data.role_id);
        if (result.state === true) {
          this.successMessage(result.message);
          this.getAll();
        }
      } else if (this.who === "peopleinfo") {
        const resultm = await mSetRole(this.permission_data.account_id, this.permission_data.role_id);
        console.log("fffffffffffffffffff", resultm);
        if (resultm.state === true) {
          this.successMessage("用户角色设置成功！");
          this.getAll();
        }
      }
      this.showDialog = false;
    },
    /**
     * 控制dialog显示与隐藏
     * @param {Boolean} value 是否显示dialog
     * @param {"create"|"modify"|"del"|"save"} key 可以选择的值
     * @param {Object} group 选中的组
     */
    async dialogChange(value, key, group) {
      console.log(arguments);
      if (value === false) {
        this.showDialog = false;
        return;
      }
      switch (key) {
        case "create":
          if (this.who === "permission") {
            this.showDialog = value;
            this.iscreate = true;
            this.dialog_title = "新建角色";
            this.permission_data = {
              role_id: [],
              role_name: [],
              account_id: ""
            }
            this.$refs.allPermissionRef.changeChecked([]);
          } else if (this.who === "peopleinfo") {
            this.showDialog = true;
            this.iscreate = true;
            this.dialog_title = "新建用户角色";
            this.permission_data = {
              role_id: [],
              role_name: [],
              account_id: ""
            }
            if (this.$refs.allPermissionRef && this.$refs.allPermissionRef.changeChecked) {
              this.$refs.allPermissionRef.changeChecked([]);
            }

            console.log("this.permission_data", this.showDialog);
          }

          break;
        case "modify":
          if (this.who === "permission") {
            this.showDialog = value;
            this.iscreate = false;
            this.dialog_title = "修改角色";
            try {
              this.permission_data = {
                role_id: group.role_id,
                role_name: group.role_name,
                account_id: group.account_id
              }
              this.RoleIdChange(group.role_id);
            } catch (e) {
              console.log("eeeeeeeeeeeeeeeeeeeeeee", e);
            }

          } else if (this.who === "peopleinfo") {
            this.showDialog = value;
            this.iscreate = false;
            this.dialog_title = "修改用户角色";
            try {
              this.permission_data = {
                role_id: group.role_id,
                role_name: group.role_name,
                account_id: group.account_id
              }
              this.RoleIdChange(group.role_id);
            } catch (e) {
              console.log("eeeeeeeeeeeeeeeeeeeeeee", e);
            }
          }

          break;
        case "del":
          if (!await showDialog()) return;
          if (this.who === "permission") {
            const delRes = await accountDe(group.account_id);
            if (delRes.state === true) {
              this.successMessage(delRes.message);
              this.getAll();
            }
          } else if (this.who === "peopleinfo") {
            const delRes = await mDeleteAccount(group.account_id);
            if (delRes.state === true) {
              this.successMessage("用户删除成功！");
              this.getAll();
            }
          }

          break;
      }
    },
    /**
    * 数据过滤
    * @param row 返回的行数据
    * @param column 返回的列信息
    */
    formatter(row, column) {
      // return row.status === "False" ? '停用' : '正常';
      if (row.role_name && row.role_name.length > 0) {
        let str = "";
        try {
          for (let i = 0; i < row.role_name.length; i++) {
            str += row.role_name[i] + "， ";
          }
        } catch (e) {
          this.warnMessage(JSON.stringify(e));
        }
        return str

      } else {
        return "未设置角色"
      }
      /* if (row.role_id && row.role_id.length > 0) {
        let str = "";
        try {
          for (let i = 0; i < row.role_id.length; i++) {
            str += row.role_id[i] + "， ";
          }
          for (let i = 0; i < row.role_name.length; i++) {
            str += row.role_name[i] + "， ";
          }
        } catch (e) {
          this.warnMessage(JSON.stringify(e));
        }
        return str

      } else {
        return "未设置角色"
      } */
    },
    /**
     * 用户的角色数组
     * @param {string[]} e 选择的角色id数组
     */
    RoleIdChange(e) {
      console.log("选择的角色id", e);
      if (e.length === 0) {
        return;
      }
      for (let i = 0; i < e.length; i++) {
        this.getGroupPermission(e[i]);
      }
    },
    /* wtyTbreturn(res) {
      console.log(res);
    }, */
    //获取所有用户角色
    /**
     * optionchange事件
     * @param {boolean} e 当选择框打开返回true 否则返回false
     */
    async optionShow(e) {
      if (e === true) {
        //TODO: 
        if (this.who === "peopleinfo" || this.who === "permission") { //服务商的permissio
          this.getRole();
        } else if (this.who === "shoppermission") {
          this.role_list = await mUserRoleList();
        }
      }
    },
    /**
     * 删除行按钮返回
     * @param {Object} row 行数据
     */
    async deleteRow(row) {
      if (this.who === "permission") {
        //店铺删除权限
        const res = await getAccountPermission(row.account_id);
        if (this.testR(res)) {
          const del = res.data.resp_data;
          var list = [];
          for (let i = 0; i < del.length; i++) {
            list.push(del[i].permission_no);
          }
          const result = await delAccountPermission(row.account_id, list);
          if (!this.testR(result)) {
            return;
          }
          this.successMessage("保存成功");
          if (this.people_list.length === 1) {
            this.people_list = [];
          } else {
            this.people_list = deleteTabRepeat(
              row.account_id,
              this.people_list,
              "account_id"
            );
          }
          this.$refs.wtyTableRef.setpeopleList(this.people_list);
          this.addPermission();
        }
      } else if (this.who === "peopleinfo") {
        //TODO:2025-04-07
        //查询用户授权
        const res = await queryAccountPermissionASMerchant(row.account_id);

        if (testR(res)) {
          /* eslint-disable */
          const del = res.data.resp_data;
          /* eslint-enable */
          const list_res = await setAccountPermissionASMerchant(
            row.account_id,
            [],
            "account_id"
          );

          if (this.testR(list_res)) {
            this.successMessage("用户删除成功！");
            this.getAll();
          }
          return;
          /*     var list = [];
                    for (let i = 0; i < del.length; i++) {
                      //删除用户授权
                      list.push(
                        delAccountPermissionASMerchant(
                          row.account_id,
                          del[i].permission_no
                        )
                      );
                    }
                    const [...result] = await Promise.all(list);
                    if (!this.testR(result[0])) {
                      this.successMessage("保存成功");
                      return;
                    }
                    if (this.people_list.length == 1) {
                      this.people_list = [];
                    } else {
                      this.people_list = deleteTabRepeat(
                        row.account_id,
                        this.people_list,
                        "account_id"
                      );
                    } */
        }
        //修改table组件里面的数据
      } else if (this.who === "shoppermission") {
        //TODO:2025-04-07
        //查询用户授权
        const mres = await permissionMerchantQuery(row.merchant_id);
        if (testR(mres)) {
          const del = mres.data.resp_data;
          /* eslint-disable */
          var list = [];
          /* eslint-enable */
          for (let i = 0; i < del.length; i++) {
            //删除用户授权
            list.push(
              permissionMerchantDelete(row.merchant_id, del[i].permission_no)
            );
          }
          const [...mresult] = await Promise.all(list);
          if (!this.testR(mresult[0])) {
            this.successMessage("保存成功");
            return;
          }
          if (this.shop_list.length === 1) {
            this.shop_list = [];
          } else {
            this.shop_list = deleteTabRepeat(
              row.merchant_id,
              this.shop_list,
              "merchant_id"
            );
          }
        }
        //修改table组件里面的数据
        this.$refs.wtyTableRef.setpeopleList(this.shop_list);
      }
      //调用新建方法
      this.addPermission();
    },
    // 修改功能 获取用户详细权限
    async updatePromiss(row, event, column) {
      if (this.who === "peopleinfo") {
        this.permission_data.account_id = row.account_id;
      } else if (this.who === "shoppermission") {
        this.permission_data.account_id = row.merchant_id;
      }
      this.accid_disabled = true;
      this.is_phone = false;
      if (this.who === "permission") {
        this.permission_data.account_id = row.account_id;
        const res = await getAccountPermission(row.account_id);
        this.changeCompPermiss(res.data.resp_data);
        this.get_checkedlist = [];
        for (let i = 0; i < res.data.resp_data.length; i++) {
          this.get_checkedlist.push(res.data.resp_data[i].permission_no);
        }
      } else if (this.who === "peopleinfo") {
        const res = await queryAccountPermissionASMerchant(row.account_id);
        this.changeCompPermiss(res.data.resp_data);
        this.get_checkedlist = [];
        for (let i = 0; i < res.data.resp_data.length; i++) {
          this.get_checkedlist.push(res.data.resp_data[i].permission_no);
        }
      } else if (this.who === "shoppermission") {
        //店铺授权的时候 查询店铺授权
        const result = await permissionMerchantQuery(row.merchant_id);
        //调用权限组件方法 修改权限
        this.changeCompPermiss(result.data.resp_data);
        //保存好线上权限
        this.get_checkedlist = [];
        for (let i = 0; i < result.data.resp_data.length; i++) {
          this.get_checkedlist.push(result.data.resp_data[i].permission_no);
        }
      }

      // permissionMerchantQuery
    },
    //新建
    addPermission() {
      // return;
      // this.$refs.peopleTableRef.setCurrentRow();
      switch (this.table_show) {
        case "peoplepermisslist":
          this.$refs.wtyTableRef.CancelHighLight();
          break;
        case "servicepermisslist":
          break;
        case "shoppermisslist":
          this.$refs.wtyTableRef.CancelHighLight();
          break;
      }
      this.permission_data.account_id = "";
      this.get_checkedlist = [];
      this.checked_list = [];
      this.changeCompPermiss([]);
      this.accid_disabled = false;
    },
    /**
     * 获取所有角色
     */
    async getRole() {
      if (this.who === "permission") {
        this.role_list = await getServiceRoleList();
      } else if (this.who === "peopleinfo") {
        this.role_list = (await mUserRoleList()).map(item => {
          return {
            role_id: item.roleId,
            role_name: item.roleName,
            permssion: item.permssion
          }
        });
      }
    },
    /**
     * 获取到用户角色
     */
    getPeopleRole() {
      if (this.who === "service") {
        this.people_list.forEach(async (item, index) => {
          try {
            let roleList = await accountQuery(item.account_id);
            let role_id = [];
            let role_name = [];
            for (let i = 0; i < roleList.length; i++) {
              role_id.push(roleList[i].role_id);
              role_name.push(roleList[i].role_name);
            }
            this.$set(item, "role_id", role_id);
            this.$set(item, "role_name", role_name);
          } catch (e) {
            this.warnMessage(JSON.stringify(e));
          }
        })
      } else if (this.who === "peopleinfo") {
        this.people_list.forEach(async (item, index) => {
          try {
            let roleList = await mQueryAccount(item.account_id);
            let role_id = [];
            let role_name = [];
            for (let i = 0; i < roleList.length; i++) {
              role_id.push(roleList[i].role_id);
              //role_name.push(roleList[i].role_name);
            }
            for (let i = 0; i < this.role_list.length; i++) {
              if (role_id.includes(this.role_list[i].role_id)) {
                role_name.push(this.role_list[i].role_name);
              }
            }
            this.$set(item, "role_id", role_id);
            this.$set(item, "role_name", role_name);
          } catch (e) {
            this.warnMessage(JSON.stringify(e));
          }
        })
      }
    },
    /**
     * 获取所有用户
     */
    async getAll() {
      this.people_list = [];
      this.shop_list = [];
      if (this.who === "permission") {
        this.people_list = await accountSearch();
        await this.getRole();
        this.getPeopleRole();
        this.all_people_list = this.people_list;
      } else if (this.who === "peopleinfo") {
        this.people_list = await mListAccount();
        await this.getRole();
        this.getPeopleRole();
        this.all_people_list = this.people_list;
      } else if (this.who === "shoppermission") {
        this.shop_list = await permissionMerchantList();
        this.$refs.wtyTableRef.setpeopleList(this.shop_list);
      }
    },
    /**
     * 保存授权
     */
    async savePermission() {
      if (this.checked_list.length === 0 && this.get_checkedlist.length === 0) {
        this.warnMessage("请选择权限");

        return;
      }
      /* if (
        localStorage.getItem("token_type") == "account" &&
        this.permission_data.account_id == localStorage.getItem("account_id")
      ) {
        this.warnMessage("不可以给自己的账号授权");
        this.addPermission();
        return;
      }
      // const setpermiss = setAccountPermission();
      if (this.permission_data.account_id == "") {
        this.warnMessage("请输入用户id！");
        return;
      } */
      //所有选中的权限
      var checked_list = [];
      this.treeData6.forEach((item, index, arr) => {
        if (this.checked_list.includes(item.label)) {
          checked_list.push(item.id);
        }
      });
      if (this.who === "peopleinfo") {
        const set_res = await setAccountPermissionASMerchant(
          this.permission_data.account_id,
          checked_list,
          this.is_phone === true ? "mobile_no" : "account_id"
        );
        if (this.testR(set_res)) {
          this.successMessage("权限修改成功！");
        }
        this.getAll();
        return;
      }

      // this.showDialog = value;
      //如果老的权限没有直接给用户授权
      if (this.get_checkedlist.length === 0) {
        try {
          let list = [];
          for (let i = 0; i < checked_list.length; i++) {
            list.push(checked_list[i]);
          }
          var list_res = null;
          if (this.who === "permission") {
            //服务商给用户授权
            list_res = await setAccountPermission(
              this.permission_data.account_id,
              list,
              this.is_phone ? "mobile_no" : "account_id"
            );
          } else if (this.who === "peopleinfo") {
            //店铺给用户授权
            list_res = await setAccountPermissionASMerchant(
              this.permission_data.account_id,
              list,
              this.is_phone ? "mobile_no" : "account_id"
            );
          } else if (this.who === "shoppermission") {
            //店铺给店铺授权

            list_res = await permissionMerchantSet(
              this.permission_data.account_id,
              list
            );
          }
          if (list_res != null) {
            if (this.testR(list_res)) {
              this.successMessage("用户授权成功！");
              this.getAll();
            }
          }
        } catch (e) {
          console.log("e", e);
        }
      } else {
        //del 需要删除的权限 add 需要添加的权限
        var list = [];
        var dele = [];
        var set_res = {};
        var del_res = {};
        //如果老的里面有的新的里面没有的加入删除数组
        for (let i = 0; i < this.get_checkedlist.length; i++) {
          if (!checked_list.includes(this.get_checkedlist[i])) {
            dele.push(this.get_checkedlist[i]);
          }
        }
        if (dele.length > 0) {
          if (this.who === "permission") {
            del_res = await delAccountPermission(
              this.permission_data.account_id,
              dele
            );
          } else if (this.who === "peopleinfo") {
            del_res = await delAccountPermissionASMerchant(
              this.permission_data.account_id,
              dele
            );
          } else if (this.who === "shoppermission") {
            del_res = await permissionMerchantDelete(
              this.permission_data.account_id,
              dele
            );
          }
        }
        //如果新的里面有的老的里面没有的加入新增数组
        for (let j = 0; j < checked_list.length; j++) {
          if (!this.get_checkedlist.includes(checked_list[j])) {
            list.push(checked_list[j]);
          }
        }
        if (list.length > 0) {
          if (this.who === "permission") {
            set_res = await setAccountPermission(
              this.permission_data.account_id,
              list
            );
          } else if (this.who === "peopleinfo") {
            set_res = await setAccountPermissionASMerchant(
              this.permission_data.account_id,
              list
            );
          } else if (this.who === "shoppermission") {
            set_res = await permissionMerchantSet(
              this.permission_data.account_id,
              list
            );
          }
        }
        if (
          set_res.data &&
          this.testR(set_res) &&
          del_res.data &&
          this.testR(del_res)
        ) {
          this.successMessage("设置权限成功！");
        } else if (set_res.data && this.testR(set_res) && !del_res.data) {
          this.successMessage("设置权限成功！");
        } else if (del_res.data && this.testR(del_res) && !set_res.data) {
          this.successMessage("删除权限成功！");
        }
        if (this.who === "peopleinfo") {
          this.updatePromiss({
            account_id: this.permission_data.account_id
          });
        } else if (this.who === "shoppermission") {
          this.updatePromiss({
            merchant_id: this.permission_data.account_id
          });
        }
      }
    },
    /**
     * 获取店铺或者是服务商的权限
     * @param {string} e role_id 需要传入的id
     */
    async getGroupPermission(e) {
      if (this.who === "permission") {
        const res = await roleQuery(e);
        if (res.length) {
          this.changeCompPermiss(res);
        }
      } else if (this.who === "peopleinfo" || this.who === "shoppermission") {
        for (let i = 0; i < this.role_list.length; i++) {
          if (this.role_list[i].role_id === e) {
            console.log("this.role_list[i].permissionList", this.role_list[i].permissionList);
            this.changeCompPermiss(this.role_list[i].permssion);
            break;
          }
        }
        // const res = await mQueryAccount(e);
        /* if (this.testR(res)) {
          this.changeCompPermiss(res);
        } */
      }
    },

    checkedChange(e) {
      this.checked_list = e;
    },
    /**
     * 修改组件中选中的权限
     */
    changeCompPermiss(list) {
      console.log("获取到的getCheckListlist=-----------------", list);

      let get_checkedlist = [];
      // this.checked_list = [];
      for (let i = 0; i < list.length; i++) {
        get_checkedlist.push(list[i]);
      }
      console.log("获取到的getCheckListlist=-----------------", get_checkedlist);

      console.log("获取到的getCheckList", get_checkedlist);
      console.log("获取到的getCheckList", this.treeData6);
      try {
        this.treeData6.forEach((item, index, array) => {
          if (get_checkedlist.includes(item.id)) {
            this.checked_list.push(item.label);
          }
        });
        //去重
        this.checked_list.get_checkedlist = Array.from(new Set(this.checked_list));
      } catch (e) {
        console.log("eeeeeeeeeeeeeeeeeeeee", e);
      }
      // this.$refs.allPermissionRef.changeChecked([]);
      this.$refs.allPermissionRef.changeChecked(this.checked_list);
    },
    async merchantSet(e) {
      /* console.log(this.who);
      console.log("123", this.table_show);
      if (this.who != "merchant") {
        return;
      }
      switch (e) {
        case 0:
          this.table_show = "peoplepermisslist";
          // this.people_list =
          this.people_list = await permissionListAccount();
          this.$refs.wtyTableRef.setpeopleList(this.people_list);
          break;
        case 1:
          this.table_show = "servicepermisslist";
          break;
        case 2:
          this.table_show = "shoppermisslist";
          this.shop_list = await permissionMerchantList();
          this.$refs.wtyTableRef.setpeopleList(this.shop_list);
          break;
      }
      this.changeCompPermiss([]); */
    },
    setColumn() {
      if (this.who === "merchant") {
        return [
          {
            prop: "group_no",
            align: "center",
            label: "组号",
            width: "200",
            fixed: false
          },
          {
            prop: "group_name",
            align: "center",
            label: "组名",
            width: "200",
            fixed: false
          },
          {
            prop: "oper_no",
            align: "center",
            label: "创建成员",
            width: "200",
            fixed: false
          },
          {
            prop: "create_time",
            align: "center",
            label: "创建时间",
            width: "300",
            fixed: false
          },
          {
            prop: "oper_time",
            align: "center",
            label: "修改时间",
            width: "200",
            fixed: false
          }
        ]
      } else if (this.who === "permission") {
        return [
          {
            prop: "account_id",
            align: "center",
            label: "用户id",
            width: "200",
            fixed: false
          },
          {
            prop: "account_id",
            align: "center",
            label: "用户号",
            width: "200",
            fixed: false
          },
          {
            prop: "account_name",
            align: "center",
            label: "用户名",
            width: "200",
            fixed: false
          },
          {
            prop: "role",
            align: "center",
            label: "用户角色",
            width: "350",
            fixed: false
          }]
      } else if (this.who === "peopleinfo") {
        return [
          {
            prop: "account_id",
            align: "center",
            label: "用户id",
            fixed: false
          }, {
            prop: "account_name",
            align: "center",
            label: "用户名",
            fixed: false
          },
          {
            prop: "role",
            align: "center",
            label: "用户角色",
            fixed: false
          }
        ]
      }
    }
  }
};
</script>

<style scoped lang="less">
.title {
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.fathera {
  width: 100%;
  height: 100%;
  min-height: 550px;
  /* max-height: 1000px; */
  // display: flex;
  border-radius: 5px;
}

.people {
  float: left;
  width: 50%;
  min-width: 600px;
  margin-bottom: 20px;

  // background-color: rgb(234, 113, 113);
  // background-color: rgb(245, 166, 166);
  .btn-fa {
    width: 100%;
    display: flex;
    justify-content: left;

    .el-button {
      width: 30%;
    }
  }

  .people-title {
    width: 100%;
    height: 45px;
    background-color: #fff;
    // display: flex;
    justify-content: space-between;
    align-items: self-end;
    font-size: 16px;
    font-weight: 700;
    // border-bottom: 1px solid #ccc;
    // padding: 0 20px;
    margin-bottom: 10px;

    .add {
      width: 30px;
      height: 30px;
      // background-color: #eaeaea;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      cursor: pointer;
      font-weight: 700;
      margin: 10px;
    }
  }
}
</style>
